export default {
    CSACountReadUserAction: {
        datapoint: {
            name: 'CSACountReadUserAction',
            customData: (actionName: string, actionSource: string): [string, string] => [
                actionName,
                actionSource,
            ],
        },
    },
    CSACountComposeUserAction: {
        datapoint: {
            name: 'CSACountComposeUserAction',
            customData: (actionName: string, actionSource: string): [string, string] => [
                actionName,
                actionSource,
            ],
        },
    },
};
